import React, { useMemo, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import Navbar from '../../components/common/Navbar';
import LoginMain from './LoginMain';
import LoginVerification from './LoginVerification';
import { VerifyEmailApi } from '../../store/features/verifyEmail';
import SuccessPopup from '../../components/common/SuccessPopup';
import FailurePopup from '../../components/common/FailurePopup';

const LoginRegistration = [0, 1];

function Login() {
  const location = useLocation();
  const takenEmail = location?.state?.takenEmail?.length > 0 ? location.state.takenEmail : '';
  const [emailFromSignUp, setEmailFromSignUp] = useState(takenEmail);
  const [selectLoginState, setSelectLoginState] = useState(
    LoginRegistration[0],
  );
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showOkayButton, setShowOkayButton] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [titleOfPopup, setTitleOfPopup] = useState('');
  const [cancelButtonText, setCancelButtonText] = useState('');

  const onCloseFailurePopup = () => {
    setShowFailurePopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  };
  const dispatch = useDispatch();

  const CheckValidation = async () => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const keyParam = searchParams.get('key');

    if (keyParam) {
      dispatch(VerifyEmailApi(keyParam))
        .then(async (response) => {
          if (!response || typeof response.payload === 'undefined') {
            Swal.fire({
              title: 'Error',
              text: 'Sorry, an error has occurred. Please try again. If the issue persists, please contact customer support.',
              icon: 'error',
              confirmButtonColor: '#148dfd',
            });
          } else if (response.payload.status === 404) {
            const settingMessage = Promise.resolve(setAlertMessage('Oops, This links is expired or already consumed.'));
            settingMessage.then(() => {
              setShowFailurePopup(true);
              setTitleOfPopup('Expired Link');
              setShowOkayButton(false);
              setShowCancelButton(true);
              setCancelButtonText('Close');
            });
          } else if (response.payload.status === 200) {
            const settingMessage = Promise.resolve(setAlertMessage('Congrats, You have been verified successfully.'));
            settingMessage.then(() => {
              setShowSuccessPopup(true);
              setTitleOfPopup('Successfully Verified');
              setShowOkayButton(false);
              setShowCancelButton(true);
              setCancelButtonText('Close');
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: 'Error',
            text: error.message,
            icon: 'error',
            confirmButtonColor: '#148dfd',
          });
        });
    }
  };
  useEffect(() => {
    CheckValidation();
  }, []);

  const LoginRegistrationUI = useMemo(() => (selectLoginState === 0 ? (
    <LoginMain
      setEmailFromSignUp={setEmailFromSignUp}
      emailFromSignUp={emailFromSignUp}
      setSelectLoginState={setSelectLoginState}
    />
  ) : (
    <LoginVerification />
  )));
  const cancelButtonAction = async () => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.delete('key');
    const newUrl = `${url.origin}${url.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
    window.history.replaceState({}, document.title, newUrl);
    setShowFailurePopup(false);
    setShowSuccessPopup(false);
  };
  return (
    <div className="main-login-container">
      {/* Popups */}
      <SuccessPopup
        show={showSuccessPopup}
        description={alertMessage}
        showOkayButton={showOkayButton}
        showCancelButton={showCancelButton}
        onOkay={onCloseFailurePopup}
        cancelText={cancelButtonText}
        onCancel={cancelButtonAction}
        displayText={titleOfPopup}
      />
      <FailurePopup
        show={showFailurePopup}
        description={alertMessage}
        showOkayButton={showOkayButton}
        showCancelButton={showCancelButton}
        onOkay={onCloseFailurePopup}
        cancelText={cancelButtonText}
        onCancel={cancelButtonAction}
        displayText={titleOfPopup}
      />
      {/* Popups */}
      <Navbar />
      {LoginRegistrationUI}
    </div>
  );
}

export default Login;
